var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEstimatesFilled = function SvgIconEstimatesFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4889 8.17725L7.82227 1.51058C7.70894 1.39725 7.55439 1.33301 7.39379 1.33301H1.93931C1.60476 1.33301 1.33325 1.60452 1.33325 1.93907V7.39361C1.33325 7.55422 1.39689 7.70877 1.51083 7.8221L8.17742 14.4888C8.2956 14.6076 8.45075 14.6663 8.6059 14.6663C8.76105 14.6663 8.9162 14.6069 9.03438 14.4888L14.4889 9.03422C14.7258 8.79786 14.7258 8.41422 14.4889 8.17725ZM4.96957 6.18149C4.29989 6.18149 3.75747 5.63907 3.75747 4.96937C3.75747 4.29967 4.29989 3.75725 4.96957 3.75725C5.63926 3.75725 6.18168 4.29967 6.18168 4.96937C6.18168 5.63907 5.63926 6.18149 4.96957 6.18149Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEstimatesFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconEstimatesFilled.802cad1c.svg";
export { ForwardRef as ReactComponent };